import { Typography } from '@mui/material';

export const TextLabel = ({ children, width}: { children: any, width?: string }) => {
  return <Typography sx={{ display: 'block' }} variant='body2' color='text.primary' width={width}>
    {children}
  </Typography>;
};
